import { useState } from 'react';
import { FiEye, FiEyeOff } from 'react-icons/fi';

const EmailToggle: React.FC<{ email: string | string[] }> = ({ email }) => {
  const [showEmail, setShowEmail] = useState(false);

  const emails = Array.isArray(email) ? email : [email];

  return (
    <div className="ml-8">
      <div className="flex items-center gap-2 cursor-pointer text-cardClr-textSecondary" onClick={() => setShowEmail(!showEmail)}>
        {showEmail ? <FiEyeOff size={16} /> : <FiEye size={16} />}
        <span className="text-xs">{showEmail ? 'Hide Email' : 'Show Email'}</span>
      </div>

      {showEmail && (
        <div className="mt-2 p-2.5 bg-white/80 rounded-md border border-slate-200/50">
          {emails.filter(Boolean).map((e, idx) => (
            <p key={idx} className="text-sm text-slate-700 leading-relaxed break-all">
              {e}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};

export default EmailToggle;
